const $ = window.jQuery;

$(function () {

  $("[sections-nav] a[href]").click(function (e) {

    e.preventDefault();

    try {

      $("#nav").headroom("unpin");
      $("#nav").headroom("freeze");

      var href = "#" + this.href.split("#")[1];

      window.scrollTo(0, $(href).offset().top);

      setTimeout(function () {

        $("#nav").headroom("unpin");
        $("#nav").headroom("unfreeze");

      }, 750);

    } catch (error) { }

  });

  $(".accordion > .accordion-item").click(function () {

    if (!$(this).hasClass("is-active")) {

      $(".accordion-item.is-active").removeClass("is-active").children(".accordion-panel").slideUp();

      $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");

    } else {

      $(".accordion-item.is-active").removeClass("is-active").children(".accordion-panel").slideUp();

    }

  });

});